import script from "./policyList.vue?vue&type=script&setup=true&lang=js"
export * from "./policyList.vue?vue&type=script&setup=true&lang=js"

import "./policyList.vue?vue&type=style&index=0&id=3694b788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3694b788"]])

export default __exports__